import * as MUTATIONS from '@/store/constants/mutations.js';

export const mutations = {
    [MUTATIONS.INCREMENT_FULLSCREEN_OVERLAY](state) {
        state.fullscreen_overlay_count += 1;
    },
    [MUTATIONS.DECREMENT_FULLSCREEN_OVERLAY](state) {
        state.fullscreen_overlay_count = Math.max(0, state.fullscreen_overlay_count - 1);
    },
};
